<template>
    <div class="detail-content">

        <!-- Tiêu đề -->
        <div class="primarylists list-mobile" v-if="!loading">
            <div class="titles clear">
                <img src="../../../static/images/icon-st.jpg" />
                <div class="title l">{{course.courseName}}</div>
            </div>
        </div>

        <!-- Controls -->
        <div class="div-icon-curi" v-if="!loading">
            <ul class="div-btn-icon">
                <template v-for="(item, index) in btns">
                    <li v-if="item.show" :key="index" @click="handleClickItem(item)">
                        <p :class="[{'btn-next-1': item.name == 'BACK'}]">
                            <img :src="item.img"/>
                            <span>{{$t(item.lg)}}</span>
                        </p>
                    </li>
                </template>
            </ul>
        </div>

        <!-- Mục lục -->
        <div class="curriculumPage">
            <div class="curriculum_components">
                <component ref="child" :is="child"></component>
            </div>
        </div>

        <!-- Popup hoàn thành -->
        <el-dialog custom-class="class1" style="padding: 0 20px;" :title="$t('new.title19')" :visible.sync="showFinished" :modal="true" :width="setDialogWidth()" :center="true">
            <template v-if="!loading">
                <div style="vertical-align: middle; text-align: center;">
                    <el-timeline style="display: inline-block; text-align: left;">
                        <el-timeline-item style="color: white;" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="course.curriculumInfo.timestamp1">
                            {{$t("new.title20")}}
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep2 == 1" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="course.curriculumInfo.timestamp2">
                            {{$t("new.title22")}}（{{course.curriculumInfo.ratio2}}）
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep2 == 2" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="course.curriculumInfo.timestamp2">
                            {{$t("new.title22") }}（{{course.curriculumInfo.ratio2}}）
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep2 == 0" icon="el-icon-s-flag" size="large" :timestamp="course.curriculumInfo.timestamp2">
                            {{ $t("new.title22") }}（{{course.curriculumInfo.ratio2}}）
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep3 == 1 && course.curriculumInfo.isExamShow == 1" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="course.curriculumInfo.timestamp3">
                            {{ $t("curriculum.exam") }}（{{course.curriculumInfo.ratio3}}）
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep3 == 2 && course.curriculumInfo.isExamShow == 1" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="course.curriculumInfo.timestamp3">
                            {{ $t("curriculum.exam") }}（{{course.curriculumInfo.ratio3}}）
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep3 == 0 && course.curriculumInfo.isExamShow == 1" icon="el-icon-s-flag" size="large" :timestamp="course.curriculumInfo.timestamp3">
                            {{ $t("curriculum.exam") }}（{{course.curriculumInfo.ratio3}}）
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep5 == 1 && course.curriculumInfo.isCovenantShow == 1" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="course.curriculumInfo.timestamp5">
                            {{ $t("curriculum.covenant") }}（{{course.curriculumInfo.ratio1}}）
                        </el-timeline-item>
                        <el-timeline-item v-if=" course.curriculumInfo.isShowStep5 == 2 && course.curriculumInfo.isCovenantShow == 1" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="course.curriculumInfo.timestamp5">
                            {{ $t("curriculum.covenant") }}（{{course.curriculumInfo.ratio1}}）
                        </el-timeline-item>
                        <el-timeline-item v-if=" course.curriculumInfo.isShowStep5 == 0 && course.curriculumInfo.isCovenantShow == 1" icon="el-icon-s-flag" size="large" :timestamp="course.curriculumInfo.timestamp5">
                            {{ $t("curriculum.covenant") }}（{{course.curriculumInfo.ratio1}}）
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep4 == 1 && course.curriculumInfo.isQuestionnaireShow == 1 && course.curriculumInfo.externalLink == null" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="course.curriculumInfo.timestamp4">
                            {{ $t("new.title65") }}（{{course.curriculumInfo.ratio4}}）
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep4 == 2 && course.curriculumInfo.isQuestionnaireShow == 1 && course.curriculumInfo.externalLink == null" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="course.curriculumInfo.timestamp4">
                            {{ $t("new.title65") }}（{{course.curriculumInfo.ratio4}}）
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep4 == 0 && course.curriculumInfo.isQuestionnaireShow == 1 && course.curriculumInfo.externalLink == null" icon="el-icon-s-flag" size="large" :timestamp="course.curriculumInfo.timestamp4">
                            {{ $t("new.title65") }}（{{course.curriculumInfo.ratio4}}）
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep6 == 1" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="course.curriculumInfo.timestamp6">
                            {{ $t("new.title21") }}（{{course.curriculumInfo.ratio5}}）
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep6 == 2" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="course.curriculumInfo.timestamp6">
                            {{ $t("new.title21") }}（{{course.curriculumInfo.ratio5}}）
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep6 == 0" icon="el-icon-s-flag" size="large" :timestamp="course.curriculumInfo.timestamp6">
                            {{ $t("new.title21") }}（{{course.curriculumInfo.ratio5}}）
                        </el-timeline-item>
                    </el-timeline>
                </div>
                <div v-if="(course.curriculumInfo.isShowStep1 != 1 || course.curriculumInfo.isShowStep2 != 1 || course.curriculumInfo.isShowStep3 != 1 || course.curriculumInfo.isShowStep4 != 1 || course.curriculumInfo.isShowStep5 != 1) && course.curriculumInfo.isFinished == 0">
                    <div class="SubmitPaper_pnn">{{ $t("new.title34") }}</div>
                </div>
                <div v-if="course.curriculumInfo.isFinished == 1">
                    <div class="SubmitPaper_pnn">{{ $t("new.title34") }}</div>
                </div>
                <div v-if=" course.curriculumInfo.isShowStep1 == 1 && course.curriculumInfo.isShowStep2 == 1 && course.curriculumInfo.isShowStep3 == 1 && course.curriculumInfo.isShowStep4 == 1 && course.curriculumInfo.isShowStep5 == 1 && course.curriculumInfo.isFinished == 0">
                    <div class="SubmitPaper_pn" @click="submit()">
                        {{ $t("new.title34") }}
                    </div>
                </div>
            </template>
        </el-dialog>

        <!-- Loading -->
        <loading :showLoading="loading" />
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import week from "./scheduleWeek";
    import loading from "@/components/loading/loading";

    export default {
        data() {
            return {
                loading: true,
                showFinished: false,
                child: week,
                userId: null,
                exams: [],
                statistics: [],
                examEnd: {},
                course: null
            };
        },
        components: {
            week,
            loading
        },
        computed: {
            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile,
            }),
        },
        created () {
            this.$autoLogin().then(
                () => {
                  this.init();
                },
                () => {
                    this.$router.push({
                        path: "/home",
                    });
                }
            );
        },
        methods: {

            // Khởi động
            init: async function () {
                // Hiện loading
                this.loading = true;

                // UserID
                this.userId = this.userId = window.sessionStorage.getItem("id");

                // Lấy data
                let outlineInfo = eval("(" + this.$route.query.outlineInfo + ")");

                // Lấy thông tin khóa học
                this.course = await this.getCourseInfo({id: outlineInfo.courseId});
                this.course['courseId'] = outlineInfo.courseId;

                // Lấy thông tin mục lục
                this.course['curriculumInfo'] = await this.getCurriculumInfo({id: this.course.courseId});

                // Lấy thông tin loại khóa học
                this.course['category'] = await this.getCourseCategory({id: this.course.courseId});

                // Lấy danh sách btns
                let btns = this.getCurriculum(this.course.category);

                // Xử lý trạng thái của btns
                this.btns = this.convertBtns(btns[0].menuList);

                // Lấy thông tin bài thi cuối kì
                this.examEnd = await this.getPastExamInfo({id: this.course.courseId});

                // Lấy thông tin bài thi giữa kì
                this.exams = await this.getExamList({id: this.course.courseId});

                // Lấy thông tin lịch sử thi
                this.statistics = await this.getsingleCourseScoreStatistics({id: this.course.courseId});

                // Tải thông tin mục lục
                this.loadMenu(this.course.courseId);

                // Ẩn loading
                this.loading = false;

                // 14. Kiểm tra trạng thái bài thi của khóa học
                let statusMidTerm = this.exams.some(item => item.status == 1);

                // 14.1 Giữa kì
                if (statusMidTerm) {
                    let message = [];
                    let h = this.$createElement;

                    message.push(h("p", null, window.vm.$i18n.t("new.title100")));

                    this.$confirm(h("p", null, message), window.vm.$i18n.t("js.hint"), {
                        confirmButtonText: window.vm.$i18n.t("js.confirm"),
                        cancelButtonText: window.vm.$i18n.t("js.cancel"),
                        cancelButtonClass: "btn-custom-cancel",
                        type: "",
                    }).then(() => {
                        this.$router.push({
                            path: "exam/mid_term",
                            query: {
                                courseId: this.course.courseId,
                                courseName: this.course.courseName,
                                redirect: true
                            },
                        });
                    }).catch(() => {});;
                }

                // 14.2 Cuối kì
                if (this.examEnd.isTemp == 1 && !statusMidTerm) {
                    let message = [];
                    let h = this.$createElement;
                    message.push(h("p", null, window.vm.$i18n.t("new.title99")));
                    this.$confirm(h("p", null, message), window.vm.$i18n.t("js.hint"), {
                        confirmButtonText: window.vm.$i18n.t("js.confirm"),
                        cancelButtonText: window.vm.$i18n.t("js.cancel"),
                        cancelButtonClass: "btn-custom-cancel",
                        type: "",
                    }).then(() => {
                        this.$router.push({
                            path: "/home/schedule/scheduleExamBegins",
                            query: {
                                courseId: this.course.courseId,
                                courseName: this.course.courseName,
                                redirect: true
                            },
                        });
                    }).catch(() => {});
                }

                // Hiển thị dialog kết thúc
                if (this.course.category != 5 && this.course.category != 6 && this.course.category != 7 && this.course.category != 8) {
                    if (
                        this.course.curriculumInfo.isShowStep1 == 1 &&
                        this.course.curriculumInfo.isShowStep2 == 1 &&
                        this.course.curriculumInfo.isShowStep3 == 1 &&
                        this.course.curriculumInfo.isShowStep4 == 1 &&
                        this.course.curriculumInfo.isShowStep5 == 1 &&
                        this.course.curriculumInfo.isShowStep6 != 1
                    ) {
                        // Load cpn hoàn thành khóa học
                        this.showFinished = true;
                    }
                }
            },

            // Load dữ liệu menu
            loadMenu: function (courseId) {
                this.$refs.child.getCourseSubOutlineListByTopOutline({courseId: courseId, courseName: this.course.courseName});
            },

            // Lấy chiều rộng dialog
            setDialogWidth: function() {
                let val = document.body.clientWidth;
                const def = 1024;

                let width = "40%";

                if (val < def) {
                    width = "90%";
                }

                return width;
            },

            // Lấy thông tin mục lục
            getCurriculumInfo: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getScheduleCurriculumInfo", {
                            courseId: data.id
                        })
                        .then(response => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response)
                        });
                });
            },

            // Lấy trạng thái đối với khóa học
            getExamStatus: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getScheduleExamStatus", {
                            courseId: data.courseId,
                            studentId: data.studentId
                        })
                        .then(response => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response)
                        });
                });
            },

            // Lấy thông tin khóa học
            getCourseInfo: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/coursesPurchase/getScheduleCoursePurchaseDetails", {
                            courseId: data.id,
                            languageType: this.$lang()
                        })
                        .then(response => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response)
                        });
                });
            },

            // Lấy thông tin loại khóa học
            getCourseCategory: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getCourseCategory", {
                            courseId: data.id,
                        })
                        .then((response) => {
                            resolve(response.data.courseCategoryCode);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Gọi đến method ứng với item
            handleClickItem: function (item) {
                if (item.medthod) {
                    this[item.medthod](item)
                }
            },

            // Xử lý menu btns
            convertBtns: function (data) {

                // Key: Bảng khảo sát
                let keyBKS = data.findIndex(item => item.name == 'BANG__KHAO__SAT');

                // Key: Câu trả lời sai
                let keyWrongAnswer = data.findIndex(item => item.name == 'CAU__TRA__LOI__SAI');

                // Key: Xuất ghi chú
                let keyNote = data.findIndex(item => item.name == 'XUAT__GHI__CHU');

                // Btn: Bảng khảo sát
                data[keyBKS]['externalLink'] = this.course.curriculumInfo.externalLink != null ? true : false;
                data[keyBKS].show = this.course.curriculumInfo.externalLink != null ? true : data[keyBKS].show;

                // Btn: Câu trả lời sai
                data[keyWrongAnswer].show = parseInt(this.course.curriculumInfo.errBookShow) == 0 ? false : data[keyWrongAnswer].show;

                // Btn: Xuất ghi chú
                let exams = [9, 10, 11, 12].filter(x => x == this.course.category);
                data[keyNote].show = this.mobile || exams.length ? false : data[keyNote].show;

                // Kiểm tra btn kết thúc

                return data;
            },

            // Lấy danh sách lịch sử thi
            getsingleCourseScoreStatistics: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/home/getsingleScheduleCourseScoreStatistics", {
                            courseId: data.id,
                            languageType: this.$lang()
                        })
                        .then((response) => {
                            resolve(response.data || []);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Lấy danh sách bài thi
            getExamList: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getScheduleExamList", {
                            courseId: data.id
                        })
                        .then((response) => {
                            resolve(response.data || []);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Lấy thông tin bài thi
            getPastExamInfo: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/studyCourseQuestion/getSchedulePastExamInfo", {
                            courseId: data.id
                        })
                        .then((response) => {
                            let result = {
                                isTemp: response.data.isTemp != null ? parseInt(response.data.isTemp) : response.data.isTemp,
                                maxScore: response.data.maxScore != null && response.data.recentScore != '--' ? parseInt(response.data.maxScore) : '--',
                                passMarks: response.data.passMarks != null ? parseInt(response.data.passMarks) : response.data.passMarks,
                                recentScore: response.data.recentScore != null && response.data.recentScore != '--' ? parseInt(response.data.recentScore) : '--',
                                isCommit: response.data.recentScore == '--' ? true : false,
                                restCount: response.data.restCount != null ? parseInt(response.data.restCount) : response.data.restCount,
                                fullMarks: response.data.fullMarks != null ? parseInt(response.data.fullMarks) : response.data.fullMarks
                            };
                            resolve(result);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Quay lại
            back: function () {
                this.$router.push({
                    name: "schedule/schedule_aicourse",
                    query: {
                        buyCourseId: this.course.courseId
                    }
                });
            },

            // Download file csv
            noteDownLoad: function () {
                this.$api
                    .post("/courseStudy/noteExport", {
                        courseId: this.course.courseId,
                        courseLanguage: this.$lang(),
                    })
                    .then((response) => {
                        window.open(response.data);
                    })
                    .catch((error) => {});
            },

            // Hiển thị câu trả lời sai
            wrongbook: function () {
                this.$router.push({
                    path: "/home/schedule/scheduleWrongbookBegin",
                    query: {
                        courseId: this.course.courseId,
                        courseName: this.course.courseName
                    },
                });
            },

            // Đi đến trang thi giữa kì
            thiGiuaKi: function () {

                // Không thể làm bài thi giữa kì vì bạn đang làm bài thi cuối kì!
                if (this.examEnd.isTemp == 1) {
                    this.$message.warning(window.vm.$i18n.t("new.title97"));
                    return;
                }

                // Xin lỗi, chưa có bài thi giữa kì nào. Vui lòng quay lại sau!
                if (this.exams.length == 0) {
                    this.$message.warning(window.vm.$i18n.t("new.title96"));
                    return;
                }

                // Bạn không thể làm lại bài thi khi đang chấm điểm bài thi. Vui lòng đợi một lúc cho đến khi việc chấm điểm hoàn tất.
                let status = this.exams.some(item => item.status == 2);
                if (this.course.curriculumInfo.isExamClick == 3 || status) {
                    this.$message.warning(window.vm.$i18n.t("js.nocorrect"));
                    return;
                }

                this.$router.push({
                    path: "/home/schedule/scheduleExamMidterm",
                    query: {
                        courseId: this.course.courseId,
                        courseName: this.course.courseName,
                        redirect: false
                    },
                });
            },

            // Đi đến trang thi cuối kì
            exam: function () {

                // Không thể làm bài thi cuối kì vì bạn đang làm bài thi giữa kì!
                let statusMidTerm = this.exams.some(item => item.status == 1);
                if (statusMidTerm) {
                    this.$message.warning(window.vm.$i18n.t("new.title98"));
                    return;
                }

                // Khoá học đã kết thúc
                if (this.course.curriculumInfo.isFinished == 1) {
                    this.$message.warning(window.vm.$i18n.t("new.title21"));
                    return;
                }

                // Khóa học vẫn chưa được mở. Có thể nội dung sẽ bị thay đổi, nên chưa thể bắt đầu [Kì thi kết thúc]. Xin hãy chờ cho đến khi khóa học được mở khoá.
                if (this.course.curriculumInfo.isLocked == 0) {
                    this.$message.warning(window.vm.$i18n.t("new.title81"));
                    return;
                }

                // Vui lòng tham gia“ kỳ thi cuối khóa ”sau khi hoàn thành tất cả nội dung học.
                if (this.course.curriculumInfo.isExamClick == 0) {
                    this.$message.warning(window.vm.$i18n.t("js.jumpToexam"));
                    return;
                }

                // Không có thông tin về kỳ thi : 125730112021
                if (this.course.curriculumInfo.isExamClick == 2) {
                    this.$message.warning(window.vm.$i18n.t("js.examDataNone"));
                    return;
                }

                // Bạn không thể làm lại bài thi khi đang chấm điểm bài thi. Vui lòng đợi một lúc cho đến khi việc chấm điểm hoàn tất.
                let statusMidTermHt = this.exams.some(item => item.status == 2);
                if (this.course.curriculumInfo.isExamClick == 3 || statusMidTermHt) {
                    this.$message.warning(window.vm.$i18n.t("js.nocorrect"));
                    return;
                }

                // Bạn không thể thi cuối kỳ vì bài tập của bạn không đạt tỷ lệ đậu.
                if (this.course.curriculumInfo.isExamClick == 4) {
                    this.$message.warning(window.vm.$i18n.t("new.title105"));
                    return;
                }

                if (this.course.curriculumInfo.isExamClick == 1) {
                    this.$router.push({
                        path: "/home/schedule/scheduleExamBegins",
                        query: {
                            courseId: this.course.courseId,
                            courseName: this.course.courseName,
                            redirect: false
                        },
                    });
                }
            },

            // Đi đến trang thành tích thi
            scoreStatistics: function () {

                // Xin lỗi, vì bạn chưa thi nên không thể xác nhận điểm của mình.
                if (this.course.curriculumInfo.isScoreStatistics == 0) {
                    this.$message.warning(window.vm.$i18n.t("new.title26"));
                    return;
                }

                // Bạn không thể kiểm tra điểm của mình trong khi chấm điểm bài kiểm tra. Vui lòng đợi một lúc cho đến khi việc chấm điểm hoàn thành.
                if (this.course.curriculumInfo.isScoreStatistics == 0 || this.statistics.length == 0) {
                    this.$message.warning(window.vm.$i18n.t("new.title27"));
                    return;
                }

                this.$router.push({
                    path: "/home/schedule/scheduleCourseScoreStatistics",
                    query: {
                        courseId: this.course.courseId,
                        courseName: this.course.courseName,
                        num: 3
                    },
                });
            },

            // Hiển thị bảng cam kết : ???
            covenant: function () {
                if (this.course.curriculumInfo.isShowStep1 == 1 && this.course.curriculumInfo.isShowStep2 == 1 && this.course.curriculumInfo.isShowStep3 == 1) {
                    this.$router.push({
                        path: "/home/schedule/scheduleCovenant",
                        query: {
                            courseId: this.course.courseId,
                            courseName: this.course.courseName,
                            templateType: 0,
                            type: 2
                        },
                    });
                } else {
                    if (this.course.curriculumInfo.isExamShow == 1) {
                        this.$message.warning(window.vm.$i18n.t("new.title48"));
                    } else if (this.course.curriculumInfo.isLocked == 0) {
                        this.$message.warning(window.vm.$i18n.t("new.title83"));
                        return;
                    } else {
                        this.$message.warning(window.vm.$i18n.t("new.title49"));
                    }
                    return;
                }
            },

            // Hiển thị bảng khảo sát
            questionnaire: function () {
                // Kiểm trả xem có phải là bảng khảo sát có kinh ngoại bộ không.
                if (this.course.curriculumInfo.externalLink != null) {
                    window.open(this.course.curriculumInfo.externalLink);
                    return;
                }
                if (this.course.curriculumInfo.isShowStep1 == 1 && this.course.curriculumInfo.isShowStep2 == 1 && this.course.curriculumInfo.isShowStep3 == 1 && this.course.curriculumInfo.isShowStep5 == 1) {
                    this.$router.push({
                        path: "/home/schedule/scheduleCovenant",
                        query: {
                            courseId: this.course.courseId,
                            courseName: this.course.courseName,
                            templateType: 1,
                            type: 1
                        },
                    });
                } else {
                    if (this.course.curriculumInfo.isCovenantShow == 1) {
                        this.$message.warning(window.vm.$i18n.t("new.title46"));
                    } else if (this.course.curriculumInfo.isExamShow == 1) {
                        this.$message.warning(window.vm.$i18n.t("js.jumpToQuestion"));
                    } else if (this.course.curriculumInfo.isLocked == 1) {
                        this.$message.warning(window.vm.$i18n.t("new.title82"));
                        return;
                    } else {
                        this.$message.warning(window.vm.$i18n.t("new.title47"));
                    }
                    return;
                }

            },

            // Hiển thị tiến độ khóa học
            finished: async function () {

                let status = await this.getExamStatus({ courseId: this.course.courseId, studentId: this.userId });

                if (status == -1) {
                    this.$confirm(window.vm.$i18n.t("new.title110"), window.vm.$i18n.t("new.title86"), { cancelButtonClass: "btn-nqt---show" })
                        .then(() => {})
                        .catch(() => {});
                    return;
                }

                // Load cpn hoàn thành khóa học
                this.showFinished = true;

            },

            // Hoàn thành khóa học
            submit: function () {
                this.$confirm(window.vm.$i18n.t("new.title35"), window.vm.$i18n.t("js.hint"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: window.vm.$i18n.t("js.confirm"),
                    cancelButtonText: window.vm.$i18n.t("js.cancel"),
                    cancelButtonClass: "btn-custom-cancel",
                }).then(() => {
                    this.$api
                        .post("/courseStudy/updateScheduleCourseFinished", {
                            courseId: this.course.courseId
                        })
                        .then((response) => {
                            this.course.curriculumInfo = response.data;

                            // Đã gửi yêu cầu kết thúc. Nhấp lại vào” Yêu cầu kết thúc ”để kiểm tra kết quả đơn đăng ký. 
                            this.$message.warning(window.vm.$i18n.t("new.title36"));

                            // Tải thông tin mục lục
                            this.loadMenu(this.course.courseId);
                        });
                }).catch(() => {});
            }
        }
    };
</script>

<style scoped>
    .disable:hover {
        cursor: context-menu;
    }
    .curriculum_page {
        width: 100%;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        display: flex;
    }

    .curriculum_main {
        width: 100%;
        min-height: 600px;
    }

    .curriculum_page_span {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: aclc(100% - 19px);
        background-color: rgba(0, 0, 0, 0.3);
    }

    .curriculumPage {
        max-width: 1024px;
        width: calc(100% - 60px);
        margin: 0 auto;
        padding-top: 140px;
        position: relative;
        padding-bottom: 50px;
    }

    .curriculumPage .page_title {
        line-height: 30px;
        font-size: 30px;
        color: #161e32;
        font-family: lato, sans-serif;
        font-weight: 300;
        font-style: normal;
    }

    .nav_content {
        max-width: 1024px;
        margin-top: 15px;
        border-bottom: 1px #414141 solid;
    }

    .nav_content ul {
        display: flex;
        justify-content: space-between;
    }

    .nav_content ul li {
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        color: #161e32;
        text-align: center;
        cursor: pointer;
        font-family: lato, sans-serif;
        font-weight: 300;
        font-style: normal;
    }
    .nav_content ul li:hover {
        color: #0071c5;
    }
    .nav_content ul li p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .nav_content_item_active {
        color: #0071c5 !important;
    }

    .curriculum_components {
        max-width: 1024px;
        min-height: 200px;
        margin: 15px auto;
    }
    .item {
        margin-top: 0px;
        margin-right: 0px;
        margin-left: 0px;
    }
    @media screen and (max-width: 1200px) {
        .curriculum_main {
            min-height: unset;
        }
    }
    .SubmitPaper_pn {
        width: 75px;
        line-height: 20px;
        padding: 4px 12px 5px 12px;
        background-color: #00b7ff;
        border: solid gba(31, 30, 30) 1px;
        cursor: pointer !important;
        color: #fff;
        font-size: 14px;
        text-align: center;
        border-radius: 20px;
        margin: 30px auto;
        font-family: source-han-sans-simplified-c, sans-serif;
        font-weight: 200;
        font-style: normal;
        transition: 0.5s ease;
        font-weight: 500;
    }

    .SubmitPaper_pn:hover {
        color: #fff;
        background-color: #00d3ff;
        transition: 0.5s ease;
        cursor: pointer;
    }

    .SubmitPaper_pnn {
        width: 75px;
        line-height: 20px;
        padding: 4px 12px 5px 12px;
        background-color: #979b9c;
        border: solidr gba(31, 30, 30) 1px;
        cursor: no-drop !important;
        color: #fff;
        font-size: 14px;
        text-align: center;
        border-radius: 20px;
        margin: 30px auto;
        font-family: source-han-sans-simplified-c, sans-serif;
        font-weight: 200;
        font-style: normal;
        transition: 0.5s ease;
        font-weight: 500;
    }
    @media (max-width: 834px) {
        .nqt-export-note {
            display: none;
        }
    }
</style>
<style>
    .class1 {
        border-radius: 10px;
        color: white;
        background-color: rgba(31, 30, 30, 0.9);
    }
    .el-timeline-item__content {
        color: white;
    }
    .el-dialog__title {
        color: white;
    }
    .btn-custom-cancel {
        float: right;
        margin-left: 10px;
        margin-top: 2px;
    }
    .primarylists .titles .title {
        text-transform: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/schedule/scheduleCurriculum.vue